import styled from 'styled-components';

export const Page = styled.main`
  min-height: calc(100vh - 90px);
  padding: 12px 16px 20px;
  background: #f5f7fa;
  color: #15213b;
  font-family: Arial, sans-serif;
  button {
    cursor: pointer;
    font: inherit;
  }
  button:focus-visible,
  input:focus-visible {
    outline: 3px solid #3f56e2;
    outline-offset: 3px;
  }
  select:focus-visible {
    outline: 3px solid #3f56e2;
    outline-offset: 3px;
  }
`;

export const Intro = styled.div`
  max-width: 1800px;
  margin: 0 auto 12px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 24px;
  .back {
    border: 0;
    background: none;
    padding: 0;
    color: #3f56e2;
    font-size: 14px;
    font-weight: 700;
  }
  h1 {
    margin: 10px 0 6px;
    font-size: 22px;
    line-height: 1.2;
  }
  p {
    margin: 0;
    color: #65728a;
    font-size: 15px;
  }
  .restart {
    flex: none;
    border: 1px solid #cbd3e0;
    border-radius: 8px;
    background: #fff;
    padding: 10px 16px;
    color: #15213b;
    font-weight: 700;
  }
  @media (max-width: 650px) {
    flex-direction: column;
    align-items: stretch;
    .restart {
      align-self: start;
    }
  }
`;

export const Progress = styled.section`
  max-width: 1440px;
  margin: 0 auto 12px;
  padding: 14px 18px;
  border: 1px solid #dce1ec;
  border-radius: 12px;
  background: #fff;
  .progress-heading {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
  .progress-heading span {
    font-weight: 700;
    color: #3f56e2;
  }
  .progress-track {
    height: 7px;
    margin: 11px 0;
    overflow: hidden;
    border-radius: 99px;
    background: #e9edfa;
  }
  .progress-track span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #3f56e2;
    transition: width 0.25s ease;
  }
  ol {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 22px;
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 13px;
    color: #65728a;
  }
  li.done {
    color: #007e62;
    font-weight: 700;
  }
  @media (prefers-reduced-motion: reduce) {
    .progress-track span {
      transition: none;
    }
  }
`;

export const ScenarioBar = styled.div`
  max-width: 1440px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 auto 16px;
  font-size: 13px;
  span {
    margin-right: 4px;
    font-weight: 700;
  }
  button {
    border: 1px solid #cbd3e0;
    border-radius: 7px;
    background: #fff;
    color: #33415a;
    padding: 6px 10px;
  }
  button:hover {
    border-color: #3f56e2;
    color: #3f56e2;
  }
  select {
    font: inherit;
    padding: 6px;
    border: 1px solid #cbd3e0;
    border-radius: 6px;
    background: white;
    color: #33415a;
    max-width: 100%;
  }
`;

export const Workspace = styled.div`
  max-width: 1800px;
  display: grid;
  grid-template-columns: 260px minmax(500px, 1fr) 280px;
  gap: 12px;
  align-items: start;
  margin: 0 auto;
  .pharmacist-side,
  .client-side {
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border: 1px solid #dce1ec;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 2px 10px #253b5610;
  }
  .pane-title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border-bottom: 1px solid #dce1ec;
    padding: 0 18px;
    font-weight: 700;
  }
  .pane-title small {
    color: #65728a;
    font-size: 12px;
    font-weight: 400;
  }
  .pharmacist-side [data-testid='loyalty-v3'] {
    min-height: 0;
  }
  .scenario-sidebar {
    display: flex;
    flex-direction: column;
    border: 1px solid #dce1ec;
    border-radius: 12px;
    background: white;
    padding: 14px;
    max-height: calc(100vh - 160px);
    overflow: auto;
    font-size: 13px;
  }
  .scenario-sidebar nav {
    order: 3;
    overflow: auto;
    min-height: 160px;
    flex: 1;
  }
  .scenario-sidebar .scenario-task {
    order: 1;
  }
  .scenario-sidebar .scenario-sync {
    order: 2;
  }
  .scenario-sidebar details {
    order: 4;
  }
  .scenario-sidebar > header,
  .scenario-sidebar > progress,
  .scenario-sidebar .scenario-task,
  .scenario-sidebar .scenario-sync,
  .scenario-sidebar details {
    flex-shrink: 0;
  }
  .scenario-sidebar header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .scenario-sidebar h2 {
    margin: 0;
    font-size: 18px;
  }
  .scenario-sidebar header span {
    color: #526079;
    font-size: 12px;
  }
  .scenario-sidebar progress {
    width: 100%;
    height: 7px;
    margin: 12px 0 4px;
    accent-color: #00876b;
  }
  .scenario-sidebar h3 {
    font-size: 12px;
    margin: 14px 0 6px;
    color: #526079;
  }
  .scenario-sidebar nav button {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 6px;
    border: 0;
    border-radius: 6px;
    background: white;
    color: #15213b;
    text-align: left;
    line-height: 1.25;
  }
  .scenario-sidebar nav button:hover {
    background: #f1f4fa;
  }
  .scenario-sidebar nav button[aria-current='step'] {
    background: #eef1ff;
    color: #334acb;
    font-weight: 700;
  }
  .scenario-done {
    color: #00876b;
    font-weight: 700;
  }
  .scenario-circle {
    color: #66758d;
  }
  .scenario-sidebar .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }
  .scenario-task {
    border-top: 1px solid #dce1ec;
    margin-top: 12px;
    padding-top: 2px;
  }
  .scenario-task h3 {
    color: #15213b;
    font-size: 14px;
  }
  .scenario-task p {
    line-height: 1.5;
    margin: 8px 0;
  }
  .scenario-task button,
  .scenario-sync button {
    border: 0;
    background: none;
    color: #334acb;
    padding: 4px 0;
    text-align: left;
  }
  .scenario-outcome {
    padding: 8px;
    border-radius: 6px;
    background: #edf8f4;
  }
  .scenario-sync {
    margin: 12px 0;
    color: #526079;
    line-height: 1.5;
    font-size: 12px;
  }
  .scenario-sync button {
    display: block;
  }
  .scenario-sidebar details {
    border-top: 1px solid #dce1ec;
    padding-top: 10px;
  }
  .scenario-sidebar summary {
    cursor: pointer;
    color: #526079;
  }
  .scenario-sidebar section[aria-label='Прогресс прохождения'] {
    padding: 10px 0;
    border: 0;
    margin: 0;
  }
  .scenario-sidebar section[aria-label='Прогресс прохождения'] ol {
    gap: 6px 10px;
  }
  .scenario-sidebar div[aria-label='Учебные ситуации'] {
    margin: 8px 0 0;
    flex-direction: column;
    align-items: stretch;
  }
  @media (min-width: 1100px) {
    .pharmacist-side {
      max-height: calc(100vh - 160px);
      overflow: auto;
    }
  }
  @media (max-width: 1200px) {
    grid-template-columns: 230px minmax(460px, 1fr) 260px;
  }
  .workspace-tabs {
    display: flex;
    gap: 4px;
    padding: 10px 14px 0;
    border-bottom: 1px solid #dce1ec;
    background: #f5f7fa;
  }
  .workspace-tabs button {
    border: 1px solid #dce1ec;
    border-bottom: 0;
    padding: 10px 12px;
    border-radius: 6px 6px 0 0;
    color: #526079;
    background: #e9edf4;
    font-size: 13px;
  }
  .workspace-tabs button[aria-selected='true'] {
    background: white;
    color: #15213b;
    font-weight: 700;
  }
  [role='tabpanel'][hidden] {
    display: none;
  }
  .client-side {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
  }
  .client-side .pane-title {
    align-self: stretch;
  }
  .phone-caption {
    max-width: 340px;
    margin: 12px 20px 0;
    color: #526079;
    text-align: center;
    font-size: 13px;
    line-height: 1.4;
  }
  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 1fr);
    .pharmacist-side,
    .client-side {
      min-height: 0;
    }
  }
`;

export const StandardPanel = styled.section`
  max-width: 1440px;
  scroll-margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 0 auto 16px;
  padding: 22px;
  border: 1px solid #b9c6e6;
  border-radius: 12px;
  background: #eef2ff;
  h2 {
    margin: 0 0 6px;
    font-size: 18px;
  }
  p {
    margin: 0 0 6px;
  }
  small {
    color: #526079;
  }
  button {
    flex: none;
    max-width: 280px;
    border: 0;
    border-radius: 8px;
    background: #3f56e2;
    color: #fff;
    padding: 12px 18px;
    font-weight: 700;
  }
  .finished {
    color: #007e62;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
    button {
      max-width: none;
    }
  }
`;

export const EntryCard = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 16px 0 24px;
  padding: 20px 24px;
  border: 1px solid #c7d1ff;
  border-radius: 12px;
  background: #f1f4ff;
  color: #15213b;
  h2 {
    margin: 0 0 6px;
    font-size: 18px;
  }
  p {
    margin: 0;
    color: #526079;
    font-size: 14px;
  }
  button {
    flex: none;
    border: 0;
    border-radius: 8px;
    padding: 11px 18px;
    background: #3f56e2;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
